import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  body: {
    font: {
      family: 'Lato, sans-serif',
    },
    width: '100%',
    textAlign: 'center',
    '@media(max-width: 450px)': {
      width: 'auto',
    },
  },
  title: {
    font: {
      size: '2.8rem',
      lineHeight: '4rem',
    },
    marginBottom: '0.4rem',
  },
  subtitle: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
    },
    margin: '0',
    color: colors.neutral[700],
  },
  form: { padding: '0 2.4rem' },
  formInput: { width: '100%', paddingTop: '3.6rem' },
  groupsSearchContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
  },
  groupProposition: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '0.1rem solid #C1C7CD',
    minHeight: '4rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.8rem 0',
    gap: '2rem',
  },
  groupNameProposition: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
    },
    textAlign: 'left',
    color: colors.blue[600],
    paddingLeft: '0.8rem',
    '&:active': {
      color: colors.blue[600],
    },
  },
  groupAvailability: {
    font: {
      size: '1.4rem',
      lineHeight: '2.4rem',
      style: 'italic',
    },
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  groupNameText: {
    textDecoration: 'none',
  },
  groupNamesList: {
    paddingLeft: 0,
  },
  noGroupPlaceholder: {
    font: {
      size: '1.4rem',
      lineHeight: '1.6rem',
    },
    color: colors.neutral[600],
    paddingTop: '2rem',
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
